let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class SideBannersController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }


  $onInit(){
    
  }

}



SideBannersController.$inject = inject;

export default SideBannersController;




// WEBPACK FOOTER //
// ./www/components/shared/components/banners/side-banners/side-banners.controller.js